// The one place in the frontend that knows the backend's legacy name for a
// study's relevance score.
//
// The product vocabulary is "relevance"; the API still sends the field under
// the retired name, and renaming it is tracked debt owned by the backend
// (STACK-480, "Out of scope for every phase"). Until that lands, every reader
// goes through here — so the retired identifier appears once, at a boundary
// that explains itself, instead of being sprinkled through the components that
// render it. When the backend rename ships, this file is the only edit.
//
// This is also why `scripts/design-system/baseline.json` still records a
// `banned-term` finding for this file and none for the components: the term is
// deliberately quarantined here, not eliminated, because the data is not ours
// to rename yet.

const LEGACY_RELEVANCE_KEY = 'effectiveness_score';

/** A study citation's relevance score, or null when it carries none. */
export const citationRelevance = (citation) => {
  const value = citation?.[LEGACY_RELEVANCE_KEY];
  if (value === null || value === undefined) return null;
  return value;
};

/** Whether a citation has a relevance score worth rendering. */
export const hasCitationRelevance = (citation) => citationRelevance(citation) !== null;

export default citationRelevance;
